import React, { Suspense, lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import SiteHeader from "@/components/common/SiteHeader";

// Wave-17 Item 1.1 — RDP submissions list lazy-loaded.
const SubmissionsList = lazy(() => import("@/pages/RDP/SubmissionsList/Page"));

export const RdpListRoute = () => (
  <div className="flex flex-col w-full min-h-full">
    <SiteHeader header="Items Awaiting Review - RDP" />
    <Suspense fallback={null}>
      <SubmissionsList />
    </Suspense>
  </div>
);

export const Route = createFileRoute("/rdp/")({
  component: RdpListRoute,
});
